export default __webpack_public_path__ + "static/media/convention20.922e4f07.png";